__turbopack_context__.v({
  "fitBarLabels": "SizeAndFit-module-scss-module__jufLdG__fitBarLabels",
  "fitBarSection": "SizeAndFit-module-scss-module__jufLdG__fitBarSection",
  "fitBarSegment": "SizeAndFit-module-scss-module__jufLdG__fitBarSegment",
  "fitBarTrack": "SizeAndFit-module-scss-module__jufLdG__fitBarTrack",
  "fitSection": "SizeAndFit-module-scss-module__jufLdG__fitSection",
  "guidanceList": "SizeAndFit-module-scss-module__jufLdG__guidanceList",
  "headingRow": "SizeAndFit-module-scss-module__jufLdG__headingRow",
  "measureContainer": "SizeAndFit-module-scss-module__jufLdG__measureContainer",
  "reviewsLink": "SizeAndFit-module-scss-module__jufLdG__reviewsLink",
  "root": "SizeAndFit-module-scss-module__jufLdG__root",
  "title": "SizeAndFit-module-scss-module__jufLdG__title",
});
